<template >
  <div class="m-gap">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {},
}
</script>
<style lang='scss' scoped>
.m-gap {
  background: #f5f7fa;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
